import { Datepicker } from 'vanillajs-datepicker';
// eslint-disable-next-line import/no-unresolved
import ru from 'vanillajs-datepicker/locales/ru';
import axios from 'axios';
import IMask from 'imask';
import fillDoctors from './formComponents/fillDoctors';

Object.assign(Datepicker.locales, ru);

export default async function FormScripts() {
  /**
   * Обработка смены табов c "Взрослым" на "Детям" и наоборот.
   * @type {NodeListOf<Element>}
   */
  const formTabs = document.querySelectorAll('.form-tabs.tabs-container .tab');
  if (formTabs) {
    formTabs.forEach((tab) => {
      tab.addEventListener('click', async function () {
        const tabsForms = document.querySelectorAll('#appointment-form-template');
        // Смена стилей для активной кнопки в самих табах
        tabsForms.forEach((parentSection) => {
          parentSection.querySelector('.tab-active').classList.remove('tab-active');
          parentSection.querySelector(`[data-tab="${this.dataset.tab}"]`).classList.add('tab-active');
        });

        /**
         * Скрыть\показать поля привязанные к типу таба. При переходе на "Детям", скрываются поля
         * предназначенные только для взрослых. И наоборот.
         */
        formTabs.forEach(() => {
          const selectedTabElems = document.querySelectorAll('[data-tabitem]');
          selectedTabElems.forEach((element) => {
            if (this.dataset.tab === element.dataset.tabitem) {
              element.classList.remove('hide-display');
            } else {
              element.classList.add('hide-display');
            }
          });
        });

        const tabsForm = this.closest('form');
        const activeTabDataset = tabsForm.querySelector('.tab-active').dataset.tab;
        const clinicSelect = tabsForm.querySelector('.clinic-select');

        // Получаем новых врачей, при смене таба с Детям на Взрослое и наоборот.
        const { data } = await axios.get('/api/get-appointment-doctors', {
          params: {
            cityId: clinicSelect.querySelector('.clinic-select .head-text').dataset.cityid,
            isChild: activeTabDataset !== 'adult_form',
          },
        });
        if (data.status) {
          // eslint-disable-next-line no-use-before-define
          fillDoctors(data, tabsForms, setDropdownItemsEvent);
        }
      });
    });
  }

  const selectsDropdown = document.querySelectorAll(' .form-item .dropdown-item .dropdown-head');
  if (selectsDropdown) {
    selectsDropdown.forEach((select) => {
      // Открытие и закрытие выпадающего списка в полях формы
      select.addEventListener('click', function (e) {
        const openDropdown = document.querySelector('.dropdown-open');
        if (openDropdown) {
          openDropdown.classList.remove('dropdown-open');
          openDropdown.querySelector('.dropdown-body').style = '';
        }
        const dropdownContainer = this.parentElement;
        if (dropdownContainer !== openDropdown) {
          if (dropdownContainer.classList.contains('dropdown-open')) {
            this.parentElement.querySelector('.dropdown-body').style = '';
            this.parentElement.classList.remove('dropdown-open');
          } else {
            let isOverflow = '';
            let openElemsCount = this.parentElement.querySelector('.dropdown-body').childElementCount;
            if (openElemsCount > 8) {
              openElemsCount = 8;
              isOverflow = 'overflow-y: scroll;';
            }
            this.parentElement.querySelector('.dropdown-body').style = `height:${this.parentElement.querySelector('.dropdown-body div').offsetHeight * openElemsCount}px;${isOverflow}`;
            this.parentElement.classList.add('dropdown-open');
          }
        }
      });
    });
  }

  // Навешивание событий на элементы выпадающего списка
  function setDropdownItemsEvent(selectsItems) {
    selectsItems.forEach((selectItem) => {
      selectItem.addEventListener('click', function (e) {
        const openDropdown = document.querySelector('.dropdown-open');
        if (openDropdown) {
          openDropdown.classList.remove('dropdown-open');
          openDropdown.querySelector('.dropdown-body').style.height = '';
        }
        const headElem = this.closest('.dropdown-item').querySelector('.dropdown-head .head-text');
        headElem.innerHTML = this.innerHTML;
        if (this.dataset.doctid) {
          headElem.dataset.doctid = this.dataset.doctid;
        }
        if (this.dataset.convtime) {
          headElem.dataset.convtime = this.dataset.convtime;
        }
      });
    });
  }

  const selectsItems = document.querySelectorAll(' .form-item .dropdown-item .dropdown-body .body-item');
  if (selectsItems) {
    setDropdownItemsEvent(selectsItems);
  }

  let appHoursArray = [];
  const clinicsSelect = document.querySelectorAll(' .form-item.clinic-select .dropdown-item .dropdown-body .body-item');
  if (clinicsSelect) {
    clinicsSelect.forEach((clinicSelect) => {
      // Обработка смены города
      clinicSelect.addEventListener('click', async function onCityChanged(e) {
        const tabsForms = document.querySelectorAll('#appointment-form-template');
        let activeTabDataset = false;
        tabsForms.forEach((tabsForm) => {
          const thisDropdownHead = tabsForm.querySelector('.clinic-select .dropdown-head');
          activeTabDataset = tabsForm.querySelector('.tab-active').dataset.tab;
          thisDropdownHead.querySelector('.head-text').dataset.cityid = clinicSelect.dataset.cityid;
          thisDropdownHead.querySelector('.head-text').innerHTML = clinicSelect.innerHTML;
        });
        // Получение и вывод докторов
        const { data } = await axios.get('/api/get-appointment-doctors', {
          params: {
            cityId: this.dataset.cityid,
            isChild: activeTabDataset !== 'adult_form',
          },
        });
        if (data.status) {
          let doctorsSelectItems = '';
          Object.entries(data.data).forEach(([key, value]) => {
            doctorsSelectItems += `  <div data-doctid="${value}" class="body-item">
                                            ${key}
                                        </div>`;
          });
          tabsForms.forEach((tabsForm) => {
            const thisDropdownHead = tabsForm.querySelector('.doctors-select .dropdown-head');
            const selectHead = thisDropdownHead.querySelector('.head-text');
            selectHead.innerText = 'Любой врач';
            selectHead.dataset.doctid = -1;
            const doctorsSelectBody = tabsForm.querySelector('.doctors-select .dropdown-body');
            doctorsSelectBody.innerHTML = doctorsSelectItems;
            setDropdownItemsEvent(doctorsSelectBody.querySelectorAll('.body-item'));
          });
        }
        // Получение и вывод информации о датах
        const data2 = await axios.get('/api/get_city_appointment_time/', {
          params: {
            cityId: this.dataset.cityid,
          },
        });
        if (data2.data.status) {
          appHoursArray = data2.data.data.app_hours_array;
          const blockedDays = [];
          const blockedDaysDesc = [];
          Object.entries(data2.data.data.blocked_dates_array).forEach((value) => {
            blockedDays.push(value[0]);
            blockedDaysDesc.push(value[1]);
          });
          setVisitTimeDatePicker(blockedDays, blockedDaysDesc);
          document.querySelectorAll('.convenient-picker').forEach((datePick) => {
            datePick.classList.remove('disabled-form-item');
          });
        }
      });
    });
  }

  const today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
  const yyyy = today.getFullYear();

  const visitTime = document.querySelectorAll('[data-inputType="visitTime"]');

  // Обработка смены даты при нажатии в дата пикере
  async function handleDatesSelection(event) {
    event.currentTarget.closest('.form-item').classList.remove('err-item');
    const weekDay = new Date(event.detail.date).getDay();
    const convenientTimeSelect = event.currentTarget.closest('#appointment-form-template').querySelector(' .form-item.convenient-time .dropdown-item');
    const timeDropdown = convenientTimeSelect.querySelector('.dropdown-body');
    let convTimeItems = '';
    const currentCity = document.querySelector('.clinic-select .dropdown-head .head-text').dataset.cityid;
    const day = String(event.detail.date.getDate()).padStart(2, '0');
    const mouth = String(event.detail.date.getMonth() + 1).padStart(2, '0'); // January is 0!
    const year = event.detail.date.getFullYear();
    const fullDate = `${year}-${mouth}-${day}`;
    const { data } = await axios.get(`/api/working-hours/change/${currentCity}/${fullDate}`, {});
    if (data !== '') {
      convTimeItems += `  <div data-convtime="${data.first_start.substring(0, 5)}-${data.first_end.substring(0, 5)}" class="body-item">
                                          с ${data.first_start.substring(0, 5)} до ${data.first_end.substring(0, 5)}
                                      </div>`;
      convTimeItems += `  <div data-convtime="${data.second_start.substring(0, 5)}-${data.second_end.substring(0, 5)}" class="body-item">
                                          с ${data.second_start.substring(0, 5)} до ${data.second_end.substring(0, 5)}
                                      </div>`;
    } else {
      appHoursArray[weekDay - 1 < 0 ? 6 : weekDay - 1].forEach((convTime) => {
        convTimeItems += `  <div data-convtime="${convTime}" class="body-item">
                                            с ${convTime[0]} до ${convTime[1]}
                                        </div>`;
      });
    }
    const headCont = convenientTimeSelect.querySelector('.dropdown-head .head-text');
    headCont.dataset.convtime = '';
    headCont.innerText = 'Удобное время';
    timeDropdown.innerHTML = convTimeItems;
    setDropdownItemsEvent(timeDropdown.querySelectorAll('.body-item'));
    convenientTimeSelect.parentElement.classList.remove('disabled-form-item');
    // return weekDay;
  }

  // Возвращает дни недели БЕЗ удобного времени
  function getDisabledWeekDays() {
    const weekDisabledDay = [];
    appHoursArray.forEach((weekDay, key) => {
      if (weekDay[0] === '-') {
        if (key === 6) {
          weekDisabledDay.push(0);
        } else {
          weekDisabledDay.push(key + 1);
        }
      }
    });
    return weekDisabledDay;
  }

  // Отрисовка календаря(И даты, и отключенные даты и подписи к ним)
  function setVisitTimeDatePicker(blockedDatesArray = [], blockedDaysDesc = []) {
    if (visitTime) {
      const weekDisabledDay = getDisabledWeekDays();

      const newBlockedDatesArray = blockedDatesArray.map((element) => {
        element = new Date(element);
        const dDay = String(element.getDate()).padStart(2, '0');
        const mMouth = String(element.getMonth() + 1).padStart(2, '0');
        const yyyYear = element.getFullYear();
        return `${dDay}-${mMouth}-${yyyYear}`;
      });
      const tomorrowDateIsMinDate = getDateOffsetByFormatting();
      visitTime.forEach((elem) => {
        if (elem.datepicker) {
          elem.datepicker.destroy();
        }
        const datepicker = new Datepicker(elem, {
          daysOfWeekDisabled: weekDisabledDay,
          format: 'dd.mm.yyyy',
          language: 'ru',
          minDate: getDateOffsetByFormatting(),
          datesDisabled: newBlockedDatesArray,
          autohide: true,
          todayBtnMode: 0,
          todayHighlight: false,
          beforeShowDay(date) {
            const dd = String(date.getDate()).padStart(2, '0');
            const mm = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
            const yyyy = date.getFullYear();
            const fullDate = `${dd}-${mm}-${yyyy}`;
            if (newBlockedDatesArray.includes(fullDate)) {
              const dateDesc = blockedDaysDesc[newBlockedDatesArray.indexOf(fullDate)];
              if (dateDesc === null) {
                return;
              }
              return {
                content: `<span class="tooltip" data-tooltip="${dateDesc}">${String(date.getDate())}</span>`,
                classes: 'has-background-info',
              };
            }
          },
        });

        const dateRangeInputEls = elem;
        if (dateRangeInputEls) {
          dateRangeInputEls.addEventListener('changeDate', handleDatesSelection);
        }
      });
    }
  }

  /**
   * Получить сегодняшнюю дату в формате {дд-мм-гггг}
   * @var {int} offset
   * @returns {string}
   */
  function getDateOffsetByFormatting(offset = 1) {
    const date = new Date();
    date.setDate(date.getDate() + offset);
    // К месяцу добавить +1, из-за того что месяцы идут от 0 до 11.
    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
  }

  // Отрисовка календаря для выбора даты рождения
  const birthDate = document.querySelectorAll('[data-inputType="birthDate"]');
  if (birthDate) {
    birthDate.forEach((elem) => {
      const datepicker = new Datepicker(elem, {
        format: 'dd.mm.yyyy',
        language: 'ru',
        autohide: true,
        maxDate: getDateOffsetByFormatting(0),
      });
      elem.addEventListener('changeDate', (e) => {
        e.currentTarget.closest('.form-item').classList.remove('err-item');
      });
    });
  }

  // Форматирование вводимых данных в поле даты "ДД.ММ.ГГГГ"
  if (birthDate) {
    birthDate.forEach(b => {
      b.addEventListener('input', function (e) {
        let value = e.target.value.replace(/\D/g, '');

        if (value.length >= 2) {
          value = value.slice(0, 2) + '.' + value.slice(2);
        }
        if (value.length >= 5) {
          value = value.slice(0, 5) + '.' + value.slice(5);
        }

        e.target.value = value;
      });
    });
  }

  /**
   * Для выбранного города подгружает актуальное расписание работы
   * @returns {Promise<void>}
   */
  async function setDateOnload() {
    const onloadCity = document.querySelector('.clinic-select');
    const q = await axios.get('/api/get_city_appointment_time/', {
      params: {
        cityId: onloadCity.querySelector('.head-text').dataset.cityid,
      },
    });
    const { data: requestData, status: requestStatus } = q.data;

    if (requestStatus) {
      appHoursArray = requestData.app_hours_array;
      const blockedDays = [];
      const blockedDaysDesc = [];
      Object.entries(requestData.blocked_dates_array).forEach((value) => {
        blockedDays.push(value[0]);
        blockedDaysDesc.push(value[1]);
      });
      setVisitTimeDatePicker(blockedDays, blockedDaysDesc);
      const dataPickers = document.querySelectorAll('.convenient-picker');
      if (dataPickers) {
        dataPickers.forEach((dataPicker) => {
          dataPicker.classList.remove('disabled-form-item');
        });
      }
    }
  }
  await setDateOnload();

  // Валидация формы
  const isRequired = (value) => value !== '';

  const checkName = (activeForm) => {
    const nameInput = activeForm.querySelector('#fio');
    const formItem = nameInput.closest('.form-item');
    if (!isRequired(nameInput.value.trim())) {
      formItem.classList.add('err-item');
      return false;
    }
    formItem.classList.remove('err-item');
    return true;
  };

  const checkParentName = (activeForm) => {
    const activeTab = activeForm.querySelector('.tab-active');
    if (activeTab.dataset.tab === 'adult_form') {
      return true;
    }
    const nameInput = activeForm.querySelector('#parent');
    const formItem = nameInput.closest('.form-item');
    if (!isRequired(nameInput.value.trim())) {
      formItem.classList.add('err-item');
      return false;
    }
    formItem.classList.remove('err-item');
    return true;
  };

  const checkConvenientDate = (activeForm) => {
    const dateInput = activeForm.querySelector('#dateInput');
    if (!isRequired(dateInput.value.trim())) {
      dateInput.closest('.form-item').classList.add('err-item');
      return false;
    }
    dateInput.closest('.form-item').classList.remove('err-item');

    return true;
  };

  const checkConvenientTime = (activeForm) => {
    const timeInput = activeForm.querySelector('.convenient-time');
    const timeInputHead = timeInput.querySelector('.dropdown-head');
    if (timeInputHead.querySelector('.head-text').dataset.convtime === '') {
      timeInput.closest('.form-item').classList.add('err-item');
      return false;
    }
    timeInput.closest('.form-item').classList.remove('err-item');

    return true;
  };

  const checkPhoneValid = (activeForm) => {
    const phoneItem = activeForm.querySelector('#phone');
    const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    const isValidRes = re.test(phoneItem.value.trim().replace(/\s/g, ''));
    if (!isValidRes) {
      phoneItem.closest('.form-item').classList.add('err-item');
      return false;
    }
    phoneItem.closest('.form-item').classList.remove('err-item');

    return true;
  };

  const checkEmailValid = (activeForm) => {
    if (checkPhoneValid(activeForm)) {
      const emailItem = activeForm.querySelector('#email');
      emailItem.closest('.form-item').classList.remove('err-item');
      return true;
    }

    const emailItem = activeForm.querySelector('#email');
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isValidRes = re.test(emailItem.value.trim().replace(/\s/g, ''));
    if (!isValidRes) {
      emailItem.closest('.form-item').classList.add('err-item');
      return false;
    }
    emailItem.closest('.form-item').classList.remove('err-item');

    return true;
  };

  const checkBirthDate = (activeForm) => {
    const dateTimeInput = activeForm.querySelector('#birthDate');
    if (!isRequired(dateTimeInput.value.trim())) {
      dateTimeInput.closest('.form-item').classList.add('err-item');
      return false;
    }
    return true;
  };

  const checkPersonal = (activeForm) => {
    const personalCheck = activeForm.querySelector('[name="agreedBox"]');
    if (!personalCheck.checked) {
      personalCheck.closest('.form-checkbox').classList.add('err-box');
      return false;
    }
    personalCheck.closest('.form-checkbox').classList.remove('err-box');

    return true;
  };

  // удаление выделения выпадающего списка при ошибке валидации
  const convenientTimeSelects = document.querySelectorAll('.convenient-time .dropdown-head');
  if (convenientTimeSelects) {
    convenientTimeSelects.forEach((convenientTimeSelect) => {
      convenientTimeSelect.addEventListener('click', () => {
        convenientTimeSelect.closest('.form-item').classList.remove('err-item');
      });
    });
  }

  // Проверка валидности формы
  function isValid(activeForm) {
    const formName = checkName(activeForm);
    const parentName = checkParentName(activeForm);
    const convenient = checkConvenientDate(activeForm);
    const convenientTime = checkConvenientTime(activeForm);
    const phone = checkPhoneValid(activeForm);
    const birthDateCheck = checkBirthDate(activeForm);
    const email = checkEmailValid(activeForm);
    const personalValid = checkPersonal(activeForm);

    return convenient
      && formName
      && parentName
      && phone
      && convenientTime
      && birthDateCheck
      && email
      && personalValid;
  }

  // Нажатие на кнопке отправить
  const formSendBtns = document.querySelectorAll('#appointment-form-template .form-send');
  if (formSendBtns) {
    // eslint-disable-next-line no-restricted-syntax
    for (const btn of formSendBtns) {
      const activeForm = btn.closest('#appointment-form-template');
      await sendAppointment(btn, activeForm);
    }
  }

  // для GTM необходимо событие взаимодействия с формой
  document.querySelectorAll('#appointment-form-template').forEach((form) => {
    form.addEventListener('change', () => {
      // отправляем событие в GTM
      if (window.dataLayer) {
        const isBottom = form.classList.contains('js-form-before-footer');
        // для формы в футере необходимо один раз добавить событие открытия формы
        // для сохранения равномерной конверсии
        if (isBottom) {
          window.dataLayer.push({
            event: 'GoalEvent',
            eventCategoryUA: 'appointment',
            eventActionUA: 'openBottomForm',
            eventGoalYM: 'appointment_openBottomForm',
            eventGA4: 'appointment_openBottomForm',
          });
        }

        // Взаимодействие с формой
        if (form.classList.contains('js-from-widget')) {
          window.dataLayer.push({
            event: 'GoalEvent',
            eventCategoryUA: 'appointmentFromWidget',
            eventActionUA: 'inputForm',
            eventGoalYM: 'appointmentFromWidget_inputForm',
            eventGA4: 'appointmentFromWidget_inputForm',
          });
        } else {
          window.dataLayer.push({
            event: 'GoalEvent',
            eventCategoryUA: 'appointment',
            eventActionUA: isBottom ? 'inputBottomForm' : 'inputTopForm',
            eventGoalYM: isBottom ? 'appointment_inputBottomForm' : 'appointment_inputTopForm',
            eventGA4: isBottom ? 'appointment_inputBottomForm' : 'appointment_inputTopForm',
          });
        }
      }
    }, { once: true });
  });

  // Функция небольшой задержки.
  // Срабатывает, когда происходит ввод данных в форме
  const debounce = (fn, delay = 100) => {
    let timeoutId;
    return (...args) => {
      // cancel the previous timer
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      // setup a new timer
      timeoutId = setTimeout(() => {
        fn.apply(null, args);
      }, delay);
    };
  };

  const tabsForms = document.querySelectorAll('#appointment-form-template input');
  tabsForms.forEach((tabsForm) => {
    // Проверка на правильность заполнения полей при потере фокуса
    tabsForm.addEventListener('blur', debounce((e) => {
      const actForm = e.target.closest('#appointment-form-template');
      switch (e.target.id) {
        case 'fio':
          checkName(actForm);
          break;
        case 'parent':
          checkParentName(actForm);
          break;
        case 'phone':
          checkPhoneValid(actForm);
          break;
        case 'email':
          checkEmailValid(actForm);
          break;
        default:
          break;
      }
    }));

    // Снятие выделения полей при вводе
    tabsForm.addEventListener('focus', debounce(() => {
      const parentItem = tabsForm.closest('.form-item');
      parentItem.classList.remove('err-item');
    }));
  });

  // Навешивание маски на поля ввода(телефоны)
  const phoneInputs = document.querySelectorAll('[name="phone"]');
  phoneInputs.forEach((phoneInput) => {
    const maskOptions = {
      mask: '+7 000 000 00 00',
      lazy: false,
    };
    const phoneMask = IMask(phoneInput, maskOptions);
  });

  /**
   * Отправка данных с формы записи на приём.
   * @returns {Promise<void>}
   */
  async function sendAppointment(button, form) {
    /**
     * Отправка формы записи на приём
     * @param {Event} event
     */
    async function sendFn(event) {
      event.preventDefault();
      let csrfMetaTag = document.querySelector('meta[name="csrf-token"]');

      if (!csrfMetaTag || !csrfMetaTag.content) {
        await axios.get('/refresh-csrf')
          .then((response) => {
            const newCsrfToken = response.data;

            if (newCsrfToken) {
              if (csrfMetaTag) {
                csrfMetaTag.content = newCsrfToken;
              } else {
                const newMetaTag = document.createElement('meta');
                newMetaTag.name = 'csrf-token';
                newMetaTag.content = newCsrfToken;
                document.head.appendChild(newMetaTag);
                csrfMetaTag = document.querySelector('meta[name="csrf-token"]');
              }
            }
          })
          .catch((error) => {
            console.error('Ошибка при получении нового токена', error);
          });
      }

      const selectedTab = form.querySelector('.tab-active').dataset.tab;

      let captcha = null;

      if (window.grecaptcha) {
        // grecaptcha.ready(function() {
        captcha = await window.grecaptcha.execute('6LcAVG4qAAAAAEDz96PRBLGGpefHeT2_LXlmiHMz', { action: 'submit' });
        // });
      }

      if (captcha && isValid(form)) {
        try {
          button.disabled = true;
          button.innerText = 'Отправление';
          const { actionId } = form.dataset;

          let metrikaClientId = '';
          let gaClientId = '';

          try {
            if (window.yaCounter50475) {
              metrikaClientId = window.yaCounter50475.getClientID();
            }
          } catch (e) {
            //
          }

          try {
            if (window.gaGlobal && window.gaGlobal.vid) {
              gaClientId = window.gaGlobal.vid;
            }
          } catch (e) {
            //
          }

          const q = await axios.post('/appointment/', {
            _token: csrfMetaTag.content,
            page_url: window.location.href,
            page_name: document.querySelector('title').innerText.trim(),
            captcha,
            appointment_date: form.querySelector('#dateInput').value,
            appoint_privacy: form.querySelector('[name="agreedBox"]').checked ? 1 : 0,
            user_full_name: form.querySelector('#fio').value.trim(),
            time_interval: form.querySelector('.convenient-time .dropdown-head .head-text').dataset.convtime.replace(',', '-'),
            pick_glasses: form.querySelector('[name="glasses_checkbox"]').checked ? 1 : 0,
            birth_date: form.querySelector('#birthDate').value,
            doctor_id: form.querySelector('.doctors-select .dropdown-head .head-text').dataset.doctid,
            city_id: form.querySelector('.clinic-select .dropdown-head .head-text').dataset.cityid.trim(),
            comment: `${form.querySelector('[name="comment"]').value.trim()} ${actionId ? `#${actionId}` : ''}`,
            parent: form.querySelector('#parent').value.trim(),
            email: form.querySelector('#email').value.trim(),
            phone: form.querySelector('#phone').value.trim(),
            isAdult: selectedTab === 'adult_form',
            metrikaClientId,
            gaClientId,
          });

          const { data, status } = q.data;
          if (status) {
            const formWrapper = form.closest('.appointment-form');
            delete form.dataset.actionId;
            formWrapper.innerHTML = data.html;

            // отправляем событие в GTM
            if (window.dataLayer) {
              if (form.classList.contains('js-from-widget')) {
                window.dataLayer.push({
                  event: 'GoalEvent',
                  eventCategoryUA: 'appointmentFromWidget',
                  eventActionUA: 'sendForm',
                  eventLabelUA: data.appointment_id,
                  eventGoalYM: 'appointmentFromWidget_sendForm',
                  eventGA4: 'appointmentFromWidget_sendForm',
                });
              } else {
                const isBottom = form.classList.contains('js-form-before-footer');
                window.dataLayer.push({
                  event: 'GoalEvent',
                  eventCategoryUA: 'appointment',
                  eventActionUA: isBottom ? 'sendBottomForm' : 'sendTopForm',
                  eventLabelUA: data.appointment_id,
                  eventGoalYM: isBottom ? 'appointment_sendBottomForm' : 'appointment_sendTopForm',
                  eventGA4: isBottom ? 'appointment_sendBottomForm' : 'appointment_sendTopForm',
                });
              }
            }
          }
        } catch (err) {
          button.disabled = false;
          button.innerText = 'Ошибка. Попробуйте еще раз';
        }
      }
    }

    button.addEventListener('click', sendFn);
  }

  const checkboxAgreeds = document.querySelectorAll('input[name="agreedBox"]');
  if (checkboxAgreeds) {
    checkboxAgreeds.forEach((box) => {
      box.addEventListener('change', () => {
        if (box.checked) {
          box.closest('.form-checkbox').classList.remove('err-box');
        } else {
          box.closest('.form-checkbox').classList.add('err-box');
        }
      });
    });
  }
}
